export const siteConfig = {
  name: '草榴社区最新网址',
  tagline: '官方入口导航',
  description: '提供草榴社区最新网址的实时更新导航，帮助用户快速找到可用入口，解决访问失效、域名变更等问题，收藏本页即可第一时间获取最新网址。',
  keywords: '草榴社区最新网址,草榴社区网址更新,草榴最新入口,草榴社区镜像地址,草榴社区访问教程,草榴社区备用网址,草榴社区官方地址',
  url: 'https://www.caoliu-dh.com',
  logo: '草榴导航',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '最新网址', href: '/category/latest-urls' },
  { label: '镜像地址', href: '/category/mirror-sites' },
  { label: '备用入口', href: '/category/alternative-links' },
  { label: '访问教程', href: '/category/tutorials' },
  { label: '关于我们', href: '/about' },
];

export const heroUrls = [
  {
    id: 'url-1',
    title: '草榴社区官方主站',
    url: 'https://www.t66y.com',
    status: '正常',
    speed: '极快',
    updatedAt: '2026-08-06',
    isRecommended: true,
  },
  {
    id: 'url-2',
    title: '草榴社区镜像站 A',
    url: 'https://cl.5678.xyz',
    status: '正常',
    speed: '快',
    updatedAt: '2026-08-05',
    isRecommended: false,
  },
  {
    id: 'url-3',
    title: '草榴社区镜像站 B',
    url: 'https://t66y.1234.xyz',
    status: '正常',
    speed: '快',
    updatedAt: '2026-08-06',
    isRecommended: false,
  },
  {
    id: 'url-4',
    title: '草榴社区备用入口 C',
    url: 'https://cl.9012.xyz',
    status: '维护中',
    speed: '较慢',
    updatedAt: '2026-08-04',
    isRecommended: false,
  },
  {
    id: 'url-5',
    title: '草榴社区备用入口 D',
    url: 'https://t66y.abcd.xyz',
    status: '正常',
    speed: '快',
    updatedAt: '2026-08-06',
    isRecommended: false,
  },
  {
    id: 'url-6',
    title: '草榴社区加速入口 E',
    url: 'https://cl.speed.xyz',
    status: '正常',
    speed: '极快',
    updatedAt: '2026-08-05',
    isRecommended: true,
  },
];

export const categories = [
  {
    slug: 'latest-urls',
    name: '最新网址',
    description: '草榴社区最新可用的官方及镜像网址，实时更新，确保您随时找到可用入口。',
    icon: 'ri-link',
    count: 28,
  },
  {
    slug: 'mirror-sites',
    name: '镜像地址',
    description: '收集整理草榴社区全球各地镜像站点，分散部署，提高访问成功率。',
    icon: 'ri-global-line',
    count: 35,
  },
  {
    slug: 'alternative-links',
    name: '备用入口',
    description: '草榴社区备用访问链接，当主站无法访问时的可靠替代方案。',
    icon: 'ri-shield-check-line',
    count: 22,
  },
  {
    slug: 'tutorials',
    name: '访问教程',
    description: '详细的草榴社区访问教程，包括DNS设置、代理配置、浏览器技巧等。',
    icon: 'ri-book-open-line',
    count: 16,
  },
];

export const articles = [
  {
    slug: 'how-to-access-caoliu-2026',
    title: '2026年草榴社区最新访问方法完整教程',
    excerpt: '本文详细介绍2026年访问草榴社区的全部方法，包括直接访问、代理设置、DNS修改等多种方式，确保您能稳定访问。',
    category: 'tutorials',
    categoryName: '访问教程',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20tech%20office%20with%20laptop%20on%20desk%2C%20warm%20ambient%20lighting%2C%20clean%20aesthetic%2C%20editorial%20photography%20style%2C%20soft%20natural%20light%2C%20professional%20workspace%2C%20neutral%20warm%20tones&width=800&height=450&seq=article-01&orientation=landscape',
    publishedAt: '2026-08-06',
    readTime: '8分钟',
    tags: ['访问教程', '新手入门', 'DNS设置'],
  },
  {
    slug: 'caoliu-mirror-sites-guide',
    title: '草榴社区镜像地址大全：最新可用镜像站汇总',
    excerpt: '全面汇总草榴社区所有已知镜像地址，包括验证状态、访问速度和稳定性评估，帮你快速选择最佳入口。',
    category: 'mirror-sites',
    categoryName: '镜像地址',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20server%20room%20with%20organized%20racks%2C%20warm%20lighting%2C%20minimalist%20tech%20aesthetic%2C%20professional%20atmosphere%2C%20soft%20ambient%20glow%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=article-02&orientation=landscape',
    publishedAt: '2026-08-05',
    readTime: '6分钟',
    tags: ['镜像地址', '网址汇总', '稳定性评估'],
  },
  {
    slug: 'dns-setup-tutorial',
    title: 'DNS设置教程：解决草榴社区无法访问问题',
    excerpt: '手把手教你修改DNS设置，解决因DNS污染导致的草榴社区无法访问问题，支持Windows、Mac、iOS和Android全平台。',
    category: 'tutorials',
    categoryName: '访问教程',
    image: 'https://readdy.ai/api/search-image?query=Clean%20desk%20setup%20with%20multiple%20screens%20showing%20network%20settings%2C%20warm%20natural%20light%2C%20minimalist%20workspace%2C%20professional%20tech%20environment%2C%20soft%20shadows%2C%20editorial%20style&width=800&height=450&seq=article-03&orientation=landscape',
    publishedAt: '2026-08-04',
    readTime: '10分钟',
    tags: ['DNS设置', '网络配置', '全平台'],
  },
  {
    slug: 'proxy-vpn-recommendation',
    title: '代理与VPN推荐：安全访问草榴社区的最佳实践',
    excerpt: '推荐适用于访问草榴社区的代理工具和VPN服务，包括免费和付费方案，以及安全使用注意事项。',
    category: 'tutorials',
    categoryName: '访问教程',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20security%20concept%20with%20lock%20icon%20on%20screen%2C%20warm%20ambient%20lighting%2C%20minimalist%20workspace%2C%20clean%20professional%20aesthetic%2C%20soft%20natural%20light%2C%20editorial%20photography&width=800&height=450&seq=article-04&orientation=landscape',
    publishedAt: '2026-08-03',
    readTime: '7分钟',
    tags: ['代理设置', 'VPN推荐', '安全访问'],
  },
  {
    slug: 'caoliu-community-guide',
    title: '草榴社区新手指南：注册、发帖与版规详解',
    excerpt: '草榴社区新人必读指南，详细介绍注册流程、发帖规范、版规说明以及如何快速融入社区。',
    category: 'tutorials',
    categoryName: '访问教程',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20nook%20with%20books%20and%20laptop%2C%20soft%20ambient%20lighting%2C%20minimalist%20interior%20design%2C%20calm%20atmosphere%2C%20editorial%20style%20photography%2C%20neutral%20warm%20tones&width=800&height=450&seq=article-05&orientation=landscape',
    publishedAt: '2026-08-02',
    readTime: '12分钟',
    tags: ['新手入门', '注册教程', '社区指南'],
  },
  {
    slug: 'browser-optimization-tips',
    title: '浏览器优化技巧：提升草榴社区访问速度',
    excerpt: '分享浏览器缓存优化、JavaScript设置、扩展插件推荐等技巧，显著提升草榴社区的加载和浏览速度。',
    category: 'tutorials',
    categoryName: '访问教程',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20browser%20window%20on%20minimalist%20desk%2C%20warm%20natural%20lighting%2C%20professional%20workspace%2C%20editorial%20photography%2C%20soft%20shadows%2C%20neutral%20warm%20background&width=800&height=450&seq=article-06&orientation=landscape',
    publishedAt: '2026-08-01',
    readTime: '5分钟',
    tags: ['浏览器优化', '访问速度', '插件推荐'],
  },
];

export const faqs = [
  {
    question: '草榴社区最新网址是什么？',
    answer: '草榴社区最新网址会定期更新。本导航页实时监控所有可用入口，确保您获取到的是当前最稳定、最快速的访问地址。建议收藏本页以便随时获取最新网址。',
  },
  {
    question: '为什么草榴社区网址经常变更？',
    answer: '由于网络环境和政策因素，草榴社区的域名可能会不定期变更或失效。我们团队24小时监控网址状态，第一时间更新可用入口，确保用户访问不中断。',
  },
  {
    question: '如何确保访问的是真正的草榴社区？',
    answer: '请始终通过本导航页提供的网址访问草榴社区。我们严格验证每个入口的真实性，避免用户误入仿冒或钓鱼网站。所有推荐网址均经过安全检测。',
  },
  {
    question: '草榴社区无法访问怎么办？',
    answer: '如果遇到无法访问的情况，请尝试以下方法：1) 切换本页提供的其他镜像地址；2) 修改DNS设置（参考我们的DNS教程）；3) 使用代理或VPN；4) 清除浏览器缓存后重试。',
  },
  {
    question: '如何收藏本导航页？',
    answer: '建议使用浏览器的书签功能收藏本页（按 Ctrl+D 或 Cmd+D），或添加到浏览器首页快捷方式。这样即使草榴社区网址变更，您也能通过本导航页快速找到最新入口。',
  },
  {
    question: '本导航页的网址更新频率是多少？',
    answer: '我们采用自动化监控加人工验证的双重机制，每30分钟检测一次所有入口的可用性。一旦发现失效网址，立即更新替换，确保导航信息的实时性和准确性。',
  },
];

export const aboutInfo = {
  brandName: '草榴社区网址导航',
  foundedYear: '2018',
  mission: '致力于为草榴社区用户提供最及时、最准确的网址导航服务，解决用户访问难题。',
  intro: '草榴社区网址导航成立于2018年，是国内最早专注于草榴社区网址收集与更新的导航平台之一。经过多年发展，我们已建立起完善的网址监控体系和用户服务机制，累计服务超过百万用户。',
  features: [
    { title: '实时更新', description: '24小时不间断监控，网址变更第一时间更新', icon: 'ri-refresh-line' },
    { title: '严格验证', description: '每个入口均经过安全检测，杜绝仿冒钓鱼网站', icon: 'ri-shield-check-line' },
    { title: '多线部署', description: '全球多地镜像节点，确保不同地区用户都能访问', icon: 'ri-server-line' },
    { title: '用户至上', description: '持续收集用户反馈，不断优化导航体验', icon: 'ri-heart-line' },
  ],
  contact: {
    email: 'admin@caoliu-dh.com',
    wechat: 'caoliu_nav',
    qq: '1234567890',
  },
};

export const categoryUrlData: Record<string, Array<{ id: string; title: string; url: string; status: string; speed: string; updatedAt: string; }>> = {
  'latest-urls': [
    { id: 'lu-1', title: '草榴社区主站入口', url: 'https://www.t66y.com', status: '正常', speed: '极快', updatedAt: '2026-08-06' },
    { id: 'lu-2', title: '草榴社区备用入口 A', url: 'https://cl.5678.xyz', status: '正常', speed: '快', updatedAt: '2026-08-06' },
    { id: 'lu-3', title: '草榴社区备用入口 B', url: 'https://t66y.1234.xyz', status: '正常', speed: '快', updatedAt: '2026-08-05' },
    { id: 'lu-4', title: '草榴社区加速入口', url: 'https://cl.speed.xyz', status: '正常', speed: '极快', updatedAt: '2026-08-06' },
    { id: 'lu-5', title: '草榴社区新域名 A', url: 'https://cl.new01.xyz', status: '正常', speed: '快', updatedAt: '2026-08-06' },
    { id: 'lu-6', title: '草榴社区新域名 B', url: 'https://t66y.new02.xyz', status: '正常', speed: '快', updatedAt: '2026-08-05' },
  ],
  'mirror-sites': [
    { id: 'ms-1', title: '亚洲镜像节点 01', url: 'https://cl-asia01.xyz', status: '正常', speed: '极快', updatedAt: '2026-08-06' },
    { id: 'ms-2', title: '亚洲镜像节点 02', url: 'https://cl-asia02.xyz', status: '正常', speed: '快', updatedAt: '2026-08-06' },
    { id: 'ms-3', title: '北美镜像节点', url: 'https://cl-na.xyz', status: '正常', speed: '快', updatedAt: '2026-08-05' },
    { id: 'ms-4', title: '欧洲镜像节点', url: 'https://cl-eu.xyz', status: '正常', speed: '一般', updatedAt: '2026-08-04' },
    { id: 'ms-5', title: '东南亚镜像节点', url: 'https://cl-sea.xyz', status: '正常', speed: '快', updatedAt: '2026-08-06' },
    { id: 'ms-6', title: '日韩镜像节点', url: 'https://cl-jk.xyz', status: '维护中', speed: '较慢', updatedAt: '2026-08-03' },
  ],
  'alternative-links': [
    { id: 'al-1', title: 'HTTPS 加密入口', url: 'https://secure.cl.xyz', status: '正常', speed: '快', updatedAt: '2026-08-06' },
    { id: 'al-2', title: 'CDN 加速入口', url: 'https://cdn.cl.xyz', status: '正常', speed: '极快', updatedAt: '2026-08-06' },
    { id: 'al-3', title: 'IP 直连入口', url: 'https://103.45.67.89', status: '正常', speed: '快', updatedAt: '2026-08-05' },
    { id: 'al-4', title: '短链接入口', url: 'https://dwz.cn/cl2026', status: '正常', speed: '一般', updatedAt: '2026-08-04' },
    { id: 'al-5', title: 'WebSocket 入口', url: 'wss://ws.cl.xyz', status: '正常', speed: '快', updatedAt: '2026-08-06' },
    { id: 'al-6', title: 'API 网关入口', url: 'https://api.cl.xyz', status: '维护中', speed: '较慢', updatedAt: '2026-08-02' },
  ],
  'tutorials': [],
};